import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import { GetShipTosApiParameter } from "@insite/client-framework/Services/CustomersService";
import { GetInvoicesApiParameter } from "@insite/client-framework/Services/InvoiceService";
import InvoiceHistoryState from "@insite/client-framework/Store/Pages/InvoiceHistory/InvoiceHistoryState";
import { UpdateSearchFieldsType } from "@insite/client-framework/Types/UpdateSearchFieldsType";
import { Draft } from "immer";

const initialState: InvoiceHistoryState = {
    getInvoicesParameter: {
        customerSequence: "-1",
        sort: "invoiceDate DESC",
    },
    filtersOpen: false,
    getShipTosParameter: {
        billToId: API_URL_CURRENT_FRAGMENT,
        filter: "",
        page: 1,
        pageSize: 20,
        expand: ["validation"],
        exclude: ["createNew"],
    },
};

const reducer = {
    "Pages/InvoiceHistory/UpdateSearchFields": (
        draft: Draft<InvoiceHistoryState>,
        action: { parameter: GetInvoicesApiParameter & UpdateSearchFieldsType },
    ) => {
        const { type } = action.parameter;
        delete action.parameter.type;
        if (type === "Replace") {
            draft.getInvoicesParameter = action.parameter;
        } else if (type === "Initialize") {
            draft.getInvoicesParameter = { ...initialState.getInvoicesParameter, ...action.parameter };
        } else {
            draft.getInvoicesParameter = { ...draft.getInvoicesParameter, ...action.parameter };

            for (const key in draft.getInvoicesParameter) {
                const value = (<any>draft.getInvoicesParameter)[key];

                // remove empty parameters
                if (value === "" || value === undefined) {
                    delete (<any>draft.getInvoicesParameter)[key];
                }
            }

            for (const key in action.parameter) {
                // go back to page 1 if any other parameters changed
                if (
                    draft.getInvoicesParameter.page &&
                    draft.getInvoicesParameter.page > 1 &&
                    key !== "page" &&
                    key !== "pageSize"
                ) {
                    draft.getInvoicesParameter.page = 1;
                }
            }
        }
    },
    "Pages/InvoiceHistory/UpdateShipTosSearchFields": (
        draft: Draft<InvoiceHistoryState>,
        action: { parameter: GetShipTosApiParameter },
    ) => {
        draft.getShipTosParameter = { ...draft.getShipTosParameter, ...action.parameter };
    },
    "Pages/InvoiceHistory/ClearParameter": (draft: Draft<InvoiceHistoryState>) => {
        draft.getInvoicesParameter = {
            ...initialState.getInvoicesParameter,
            pageSize: draft.getInvoicesParameter.pageSize,
        };
    },
    "Pages/InvoiceHistory/ToggleFiltersOpen": (draft: Draft<InvoiceHistoryState>) => {
        draft.filtersOpen = !draft.filtersOpen;
    },
    "Pages/InvoiceHistory/BeginExportInvoices": (draft: Draft<InvoiceHistoryState>) => {
        draft.isExportingInvoices = true;
    },
    "Pages/InvoiceHistory/CompleteExportInvoices": (draft: Draft<InvoiceHistoryState>) => {
        draft.isExportingInvoices = false;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
